export const heroHeaderId = 'hero-header-wrapper';
export const heroSubheaderId = 'hero-subheader-wrapper';
export const heroImageId = 'hero-image-wrapper';
